import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const saasApi = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

saasApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('saas_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

saasApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('saas_token');
      localStorage.removeItem('saas_admin');
      window.location.href = '/saas-admin';
    }
    return Promise.reject(err);
  }
);

export const saasAuth = {
  login: (username, password) => saasApi.post('/api/saas/auth/login', { username, password }),
  me: () => saasApi.get('/api/saas/auth/me'),
};

export const saasDashboard = {
  get: () => saasApi.get('/api/saas/dashboard'),
};

export const saasTenants = {
  list: (params) => saasApi.get('/api/saas/tenants', { params }),
  get: (id) => saasApi.get(`/api/saas/tenants/${id}`),
  stats: (id) => saasApi.get(`/api/saas/tenants/${id}/stats`),
  create: (data) => saasApi.post('/api/saas/tenants', data),
  update: (id, data) => saasApi.put(`/api/saas/tenants/${id}`, data),
  freeze: (id, reason) => saasApi.post(`/api/saas/tenants/${id}/freeze`, { reason }),
  unfreeze: (id) => saasApi.post(`/api/saas/tenants/${id}/unfreeze`),
  extend: (id, newEndDate) => saasApi.post(`/api/saas/tenants/${id}/extend`, { new_end_date: newEndDate }),
  forcePasswordReset: (id) => saasApi.post(`/api/saas/tenants/${id}/force-password-reset`),
  sendQrCard: (id, body = {}) => saasApi.post(`/api/saas/tenants/${id}/send-qr-card`, body),
  resetToZero: (id, password) => saasApi.post(`/api/saas/tenants/${id}/reset-to-zero`, { confirmation: 'RESET', password }),
  deleteTenant: (id) => saasApi.delete(`/api/saas/tenants/${id}`),
  uploadLogo: (id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return saasApi.post(`/api/saas/tenants/${id}/logo`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteLogo: (id) => saasApi.delete(`/api/saas/tenants/${id}/logo`),
  uploadAppIcon: (id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return saasApi.post(`/api/saas/tenants/${id}/app-icon`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteAppIcon: (id) => saasApi.delete(`/api/saas/tenants/${id}/app-icon`),
  listUsers: (id) => saasApi.get(`/api/saas/tenants/${id}/users`),
  createUser: (id, data) => saasApi.post(`/api/saas/tenants/${id}/users`, data),
  promoteUserToGm: (id, userId) => saasApi.post(`/api/saas/tenants/${id}/users/${userId}/promote-to-gm`),
  createBranch: (id, data) => saasApi.post(`/api/saas/tenants/${id}/branches`, data),
};

export const saasBackups = {
  createTenant: (tenantId, notes?) => saasApi.post(`/api/saas/backups/tenant/${tenantId}`, { notes }),
  createCentral: (notes?) => saasApi.post('/api/saas/backups/central', { notes }),
  list: (params?) => saasApi.get('/api/saas/backups', { params }),
  get: (id) => saasApi.get(`/api/saas/backups/${id}`),
  download: (id) => saasApi.get(`/api/saas/backups/${id}/download`, { responseType: 'blob' }),
  validate: (id) => saasApi.post(`/api/saas/backups/${id}/validate`),
  restore: (id, password, skipSafety = false) => saasApi.post(`/api/saas/backups/${id}/restore`, { password, skip_safety_backup: skipSafety }),
  delete: (id) => saasApi.delete(`/api/saas/backups/${id}`),
  cleanup: () => saasApi.post('/api/saas/backups/cleanup'),
  auditLog: (params?) => saasApi.get('/api/saas/backups/audit/log', { params }),
};

export default saasApi;
